import { Component, Watch } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';
import EditorApi from '@/apis/editor-api';
import { EUserAdEvent } from '@/helpers/user';
import UtilHelper from '@/helpers/utils';
import { EAnalyticsEvent } from '@/helpers/analytic';
import EditorBase from './EditorBase';
import { StreamStatsFPSHealthBrackets } from '@/helpers/editor';

@Component({
  components: {
    SButton: Button
  }
})
export default class StreamStatus extends EditorBase {
  showGoingLiveMessage: boolean = false;

  mounted() {
    this.loadStreamStatus();
  }

  get isPreview() {
    return this.streamStatus === 'Preview';
  }

  get streamStatusText(): string {
    if (this.isPreview) {
      return '<i class="icon-view"></i> Preview';
    }

    return this.isLive ? 'Online' : 'Offline';
  }

  get bracketKey(): string {
    return `${this.streamStats.rtmp_height}@${this.streamStats.fps}`;
  }

  get latencyImage(): string {
    let bracketKey = this.bracketKey;

    if (!StreamStatsFPSHealthBrackets[bracketKey]) {
      bracketKey = '720@30';
    }

    if (this.streamStats.mb_sec > StreamStatsFPSHealthBrackets[bracketKey].full) {
      return 'https://cdn.streamlabsstudio.com/static/imgs/icons/wifi_signal_full.png';
    } else if (this.streamStats.mb_sec > StreamStatsFPSHealthBrackets[bracketKey].half) {
      return 'https://cdn.streamlabsstudio.com/static/imgs/icons/wifi_signal_half.png';
    } else if (this.streamStats.mb_sec > StreamStatsFPSHealthBrackets[bracketKey].quarter) {
      return 'https://cdn.streamlabsstudio.com/static/imgs/icons/wifi_signal_quarter.png';;
    }

    return 'https://cdn.streamlabsstudio.com/static/imgs/icons/wifi_signal_empty.png';
  }

  async onGoLiveClick() {
    if (!this.isPreview) {
      return;
    }

    const response = await EditorApi.goLive(`${this.previewBaseUrl}/api/v1/preview/${this.currentUser.stream_key}/go_live`);
  }

  @Watch('isLive')
  showMessage() {
    if (this.isLive) {
      UtilHelper.trackGTMEvent({ event: EUserAdEvent.goLive });

      this.$sla.sendEvent(EAnalyticsEvent.goLive);
      this.$sla.sendEvent(EAnalyticsEvent.streamSettings, { settings: this.selectedProject?.settings?.resolution });
      this.$sla.sendEvent(EAnalyticsEvent.layerSettings, { settings: this.components });
      this.showGoingLiveMessage = true;

      setTimeout(() => {
        this.showGoingLiveMessage = false;
      }, 5000);
    }
  }
}
